import { useGT } from 'gt-react';
import { hasActiveTroubleValue } from '@/components/common/troubleEntries';
import type { NeedGroup } from '../utils/needRows';

export function NeedSalesOrderCell({ need }: { need: NeedGroup }) {
  const gt = useGT();
  const held = need.open.filter((line) =>
    hasActiveTroubleValue(line.triggerSalesOrderTroubleData, 'CREDIT_HOLD'),
  ).length;
  return (
    <span className="flex items-center gap-1.5 whitespace-nowrap text-xs tabular-nums">
      <span className="text-muted-foreground">
        {gt('{count} SOs', {
          count: need.salesOrderCount,
          context: 'buyer board need row, count of sales order lines',
        })}
      </span>
      {held > 0 && (
        <span
          className="font-medium text-rose-700"
          title={gt('{count} on credit hold', {
            count: held,
            context: 'buyer board need row, credit-held sales orders hover',
          })}
        >
          ⚑{held}
        </span>
      )}
    </span>
  );
}
